module.exports = __webpack_public_path__ + "img/2f_r_kasuya.ab150e82.jpg";